import * as React from "react";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import LinearProgress, {
  linearProgressClasses
} from "@mui/material/LinearProgress";

const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
    height: 16,
    borderRadius: 15,
    [`&.${linearProgressClasses.colorPrimary}`]: {
      backgroundColor: "#FFEE78"
    },
    [`& .${linearProgressClasses.bar}`]: {
      borderRadius: 0 ,
      backgroundColor: "#FF8b4b"
    }
  }));

const ProgressBar = () => {
    return (
        <Box sx={{ flexGrow: 1 }}>
          <br />
          <BorderLinearProgress variant="determinate" value={20} />
        </Box>
      );
}

export default ProgressBar